export const SYNC_MESSAGE = {
  SYNC_COMPLETE: 'Sync data completely',
  SYNC_FAILED: 'Sync failed'
};

export const VERIFY_MESSAGE = {
  INVALID_FORMAT: 'AdminHTML.Constants.Message.verifyMessage_InvalidFormat',
  ORTHER: 'AdminHTML.Constants.Message.verifyMessage_Orther'
};

export const VERIFY_MESSAGE_SUGGESTION = {
  ...VERIFY_MESSAGE,
  INVALID_INPUT: 'AdminHTML.Constants.Message.verifyMessage_InvalidFormat',
  EXCEEDED_TERM_LIMIT: 'AdminHTML.Constants.Message.verifyMessage_InvalidFormat'
};

export const VERIFY_MESSAGE_REDIRECT = {
  ...VERIFY_MESSAGE,
  INVALID_INPUT: 'AdminHTML.Constants.Message.verifyMessageSuggestion_InvalidInput',
  EXCEEDED_TERM_LIMIT: 'AdminHTML.Constants.Message.verifyMessageSuggestion_ExceedTermLimit'
};

export const VERIFY_MESSAGE_SYNONYM = {
  ...VERIFY_MESSAGE,
  INVALID_INPUT: `AdminHTML.Constants.Message.verifyMessageSynonym_InvalidInput`,
  EXCEEDED_TERM_LIMIT: `AdminHTML.Constants.Message.verifyMessageSynonym_InvalidInput`
};

export const VERIFY_MESSAGE_STOPWORD = {
  ...VERIFY_MESSAGE,
  INVALID_INPUT: `AdminHTML.Constants.Message.verifyMessageStopWords_InvalidInput`,
  EXCEEDED_TERM_LIMIT: `AdminHTML.Constants.Message.verifyMessageStopWords_ExceedTermLimit`
};

export const ANALYTICS = {
  ERROR_REQUEST: 'AdminHTML.Analytics.Constants.message_ErrorRequest'
};

export const BACKEND_MESSAGES = {
  // INVALID_FORMAT:
  INVALID_FORMAT_CSV_JSON: 'AdminHTML.Constants.Message.backendMessage_InvalidFormat1',
  INVALID_FORMAT_CSV: 'AdminHTML.Constants.Message.backendMessage_InvalidFormat1',
  INVALID_FORMAT_CSV_REDIRECTS: 'AdminHTML.Constants.Message.backendMessage_InvalidFormat2',
  INVALID_FORMAT_URL_REDIRECT: 'AdminHTML.Constants.Message.backendMessage_InvalidFormat3',
  INVALID_FORMAT_CSV_STOP_WORDS: 'AdminHTML.Constants.Message.backendMessage_InvalidFormat2',
  INVALID_FORMAT_SUGGESTIONS: 'AdminHTML.Constants.Message.backendMessage_InvalidFormat4',
  INVALID_FORMAT_CSV_SUGGESTIONS: 'AdminHTML.Constants.Message.backendMessage_InvalidFormat2',
  INVALID_FORMAT_CSV_SYNONYMS: 'AdminHTML.Constants.Message.backendMessage_InvalidFormat2',
  // INVALID_INPUT:
  INVALID_INPUT_EMPTY_PRODUCT_RANKINGS: 'AdminHTML.Constants.Message.backendMessage_InvalidInput1',
  INVALID_INPUT_ID_REQUIRED_PRODUCT_RANKINGS:
    'AdminHTML.Constants.Message.backendMessage_InvalidInput2',
  INVALID_INPUT_FIELDS_REQUIRED_PRODUCT_RANKINGS:
    'AdminHTML.Constants.Message.backendMessage_InvalidInput3',
  INVALID_INPUT_DATE_FORMAT_PRODUCT_RANKINGS:
    'AdminHTML.Constants.Message.backendMessage_InvalidInput4',
  INVALID_INPUT_TERMS_REDIRECTS: 'AdminHTML.Constants.Message.backendMessage_InvalidInput5',
  INVALID_INPUT_TERMS_STOP_WORDS: 'AdminHTML.Constants.Message.backendMessage_InvalidInput5',
  INVALID_INPUT_TERMS_SUGGESTIONS: 'AdminHTML.Constants.Message.backendMessage_InvalidInput5',
  INVALID_INPUT_TERMS_SYNONYMS: 'AdminHTML.Constants.Message.backendMessage_InvalidInput5',
  // EXCEEDED_TERM_LIMIT:
  EXCEEDED_TERM_LIMIT_PRODUCT_RANKINGS:
    'AdminHTML.Constants.Message.backendMessage_ExceededTermLimit1',
  EXCEEDED_TERM_LIMIT_ANALYTICS: 'AdminHTML.Constants.Message.backendMessage_ExceededTermLimit2',
  EXCEEDED_TERM_LIMIT_MERCHANDISINGS:
    'AdminHTML.Constants.Message.backendMessage_ExceededTermLimit3',
  EXCEEDED_TERM_LIMIT_MAXIMUM_NUMBER_REDIRECTS:
    'AdminHTML.Constants.Message.backendMessage_ExceededTermLimit4',
  EXCEEDED_TERM_LIMIT_MAXIMUM_CHAR_REDIRECTS:
    'AdminHTML.Constants.Message.backendMessage_ExceededTermLimit5',
  EXCEEDED_TERM_LIMIT_MAXIMUM_NUMBER_STOP_WORDS:
    'AdminHTML.Constants.Message.backendMessage_ExceededTermLimit6',
  EXCEEDED_TERM_LIMIT_MAXIMUM_CHAR_STOP_WORDS:
    'AdminHTML.Constants.Message.backendMessage_ExceededTermLimit5',
  EXCEEDED_TERM_LIMIT_MAXIMUM_CHAR_SUGGESTIONS:
    'AdminHTML.Constants.Message.backendMessage_ExceededTermLimit5',
  EXCEEDED_TERM_LIMIT_MAXIMUM_NUMBER_SYNONYMS:
    'AdminHTML.Constants.Message.backendMessage_ExceededTermLimit7',
  EXCEEDED_TERM_LIMIT_MAXIMUM_CHAR_SYNONYMS:
    'AdminHTML.Constants.Message.backendMessage_ExceededTermLimit5'
};
